import { FontAwesomeIcon } from 'module/ui/components/atoms/icon/icon';
import {
  ExpandableSearchInput,
  ExpandableSearchInputRef,
} from 'module/ui/components/atoms/input/search-input';
import { CenterAlignedBox } from 'module/ui/components/atoms/layout/layout';
import { PageLoading } from 'module/ui/components/atoms/loading';
import { MoreActionsDropdown } from 'module/ui/components/atoms/more-actions';
import { faDownload } from '@fortawesome/pro-regular-svg-icons';
import { useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { AccountPeopleBoard } from 'components/organisms/account-people/board';
import { usePeopleByRole } from 'components/organisms/account-people/board/people-groupby-role';
import { useAccountPeoplePageParams } from 'components/organisms/account-people/utils/use-page-params';
import { PeoplePageRoleSelector } from '../../../../organisms/account-people/board/role-selector';
import { AccountPeopleViewSwitcher } from '../../../../organisms/account-people/view-switcher';
import { AccountLayout } from '../common/layout';
import { AccountsTabs, AccountsTabsType } from '../common/tab';
import { useCompanyFromUrl } from '../use-current-company';

const ActionBarWrapper = styled(CenterAlignedBox)``;

export const AccountPeopleBoardPage = () => {
  const { data: company, isLoading: isCompanyLoading } = useCompanyFromUrl();
  const { params, onParamsChange } = useAccountPeoplePageParams();
  const searchInputRef = useRef<ExpandableSearchInputRef>(null);
  const {
    people,
    lastMeetingParticipants,
    isLoading: isPeopleLoading,
  } = usePeopleByRole({
    company: company!,
    role: params.role,
  });

  return isCompanyLoading || company == null || isPeopleLoading ? (
    <PageLoading />
  ) : (
    <AccountLayout
      company={company}
      tabs={<AccountsTabs activeKey={AccountsTabsType.People} />}
      content={
        <AccountPeopleBoard
          pageParams={params}
          clearSearch={() => {
            onParamsChange({ searchQuery: '' });
            searchInputRef.current?.closeSearchInput();
          }}
          people={people}
          lastMeetingParticipants={lastMeetingParticipants}
        />
      }
      actions={{
        primary: (
          <ActionBarWrapper>
            <AccountPeopleViewSwitcher />
          </ActionBarWrapper>
        ),
        central: (
          <PeoplePageRoleSelector
            value={params.role}
            onChange={(role) => onParamsChange({ role })}
            people={people}
          />
        ),
        secondary: (
          <ActionBarWrapper>
            <ExpandableSearchInput
              ref={searchInputRef}
              direction="right"
              value={params.searchQuery}
              onChange={(event) =>
                onParamsChange({ searchQuery: event.target.value })
              }
              searchButtonProps={{
                type: 'text',
              }}
              minWidth="360px"
            />
            <MoreActionsDropdown
              menu={{
                items: [
                  {
                    type: 'group',
                    label: <FormattedMessage id="more_actions" />,
                    children: [
                      {
                        key: 'export',
                        label: <FormattedMessage id="export" />,
                        icon: <FontAwesomeIcon icon={faDownload} size={12} />,
                      },
                    ],
                  },
                ],
              }}
            />
          </ActionBarWrapper>
        ),
      }}
    />
  );
};
